import { Box, Divider, makeStyles, Theme, Typography } from '@material-ui/core';
import moment from 'moment';
import React, { useState } from 'react';
import ReactPlayer from 'react-player/youtube';
import { useHistory } from 'react-router-dom';

import { cardButtonsData } from '../../../../config/cardButtonsData';
import noImage from '../../../../shared/assets/no-image.png';
import { Button } from '../../../../shared/components/Button';
import { CardButtons } from '../../../../shared/components/CardButtons';
import { CardButtonItem } from '../../../../shared/components/CardButtons/CardButtonItem';
import { PageContainer } from '../../../../shared/components/PageContainer';
import { useBlog } from '../../../../shared/hooks/reactQuery/useBlog';
import { useModalYourRegistration } from '../../../../shared/hooks/useModalYourRegistration';
import { usePremium } from '../../../../shared/hooks/usePremium';
import { Ads } from '../../../ads';
import { FullPageAdModal } from '../../../ads/fullPageAdModal';
import { Header } from '../../../authentication/components/Header';
import { BePremium } from '../../components/BePremium';
import HtmlClamp from '../../components/htmlClamp';

export const useStyles = makeStyles((theme: Theme) => ({
  asideRight: {
    position: 'fixed',
    top: 0,
    bottom: 72,
    right: 0,
    width: 350,
    borderLeft: '1px solid #ddd',
    paddingTop: 80,
    padding: 20,
    overflowY: 'auto',
    boxShadow: theme.shadows[4],

    height: '100vh',

    [theme.breakpoints.down(1280)]: {
      width: 260,
    },

    [theme.breakpoints.down(1114)]: {
      width: 230,
    },

    [theme.breakpoints.down(1040)]: {
      display: 'none',
    },
  },
}));

function Home() {
  const history = useHistory();
  const isPremium = usePremium();
  const { onOpen: onOpenYourRegistration } = useModalYourRegistration();

  const { data } = useBlog();

  function handlePushOrOpenModal(
    route: string,
    onOpenModal?: 'yourRegistration' | 'otherModal'
  ) {
    if (onOpenModal) {
      switch (onOpenModal) {
        case 'yourRegistration':
          onOpenYourRegistration();
          break;

        default:
          break;
      }
    } else {
      history.push(route);
    }
  }

  return (
    <>
      <PageContainer display="flex" flexDirection="column">
        <BePremium />
        <Box display={{ xs: 'block', md: 'none' }}>
          <BlogList />
        </Box>

        {cardButtonsData.map((content) => {
          return (
            <CardButtons key={content.sectionName} title={content.sectionName}>
              {content.buttons.map((button) => {
                return (
                  <CardButtonItem
                    key={`${button.name}-${content.sectionName}`}
                    name={button.name}
                    premiumContent={!!button?.isPremiumRequired}
                    isDisabled={
                      button?.isPremiumRequired === true && !isPremium
                    }
                    isNew={button.isNew}
                    icon={button.icon}
                    isLoading={isPremium === undefined}
                    onClick={() =>
                      handlePushOrOpenModal(
                        `${button.toPage}`,
                        button.onOpenModal
                      )
                    }
                  />
                );
              })}
            </CardButtons>
          );
        })}
        <Ads />
        <FullPageAdModal />
      </PageContainer>
      {isPremium && data && data.pages.length === 0 && <AsideRight />}
    </>
  );
}

function BlogList({ isAside = false }) {
  const history = useHistory();
  const { data } = useBlog();

  if (!data || data.pages.length === 0 || data.pages[0].results.length === 0) {
    return null;
  }

  return (
    <>
      <Typography
        color="secondary"
        variant="h6"
        style={{ fontWeight: 'bold', color: '#F9836F', fontSize: '20px' }}
      >
        Blog
      </Typography>

      {data.pages.map((group, index) => (
        <React.Fragment key={index}>
          {group.results.slice(0, 1).map((item) => (
            <Box
              key={item.id}
              onClick={() => history.push(`/information/blog`)}
              style={{
                width: '80%',
                background: '#fff',
                borderRadius: 10,
                boxShadow: '0 1px 2px rgba(0,0,0,0.15)',
                marginBottom: 5,
                padding: 12,
                margin: 'auto',
                maxHeight: 350,
              }}
            >
              <Typography
                variant="body2"
                style={{
                  color: '#777',
                  fontSize: 12,
                  marginBottom: 4,
                }}
              >
                {moment(item.created_at).format('DD [de] MMMM [às] HH:mm')}
              </Typography>

              <Typography
                variant="h6"
                style={{
                  fontWeight: 600,
                  marginBottom: 6,
                  color: '#1d1d1d',

                  fontSize: '1.05rem',
                }}
              >
                {item.title}
              </Typography>

              {/* IMAGEM / VÍDEO */}
              <Box
                style={{
                  width: '100%',
                  height: '200px',
                  overflow: 'hidden',
                  borderRadius: 8,
                  background: '#000',

                  maxHeight: 180,
                }}
              >
                {item.url ? (
                  <ReactPlayer
                    url={item.url}
                    width="100%"
                    height="180px"
                    controls={false}
                    playing={false}
                  />
                ) : (
                  <img
                    src={item.image_url ?? noImage}
                    alt={item.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                )}
              </Box>

              <HtmlClamp html={item.description} />
            </Box>
          ))}
        </React.Fragment>
      ))}

      <Button
        style={{ margin: '15px auto' }}
        size="small"
        variant="contained"
        color="primary"
        onClick={() => history.push('/information/blog')}
      >
        Ver mais
      </Button>

      {!isAside && <Divider style={{ marginBottom: 20, marginTop: 20 }} />}
    </>
  );
}

function AsideRight() {
  const classes = useStyles();
  return (
    <aside className={classes.asideRight}>
      <BlogList isAside />
    </aside>
  );
}

export { Home };
